export const SET_SEARCHOPTIONS_VIEW = "SET_SEARCHOPTIONS_VIEW";
export const SET_SHOW_SEARCH_OPTIONS = "SET_SHOW_SEARCH_OPTIONS";
export const SET_MODULES = "SET_MODULES";
export const PAN_TO_STOP = "PAN_TO_STOP";

interface ActionTypes {
  SET_SEARCHOPTIONS_VIEW: string;
  SET_SHOW_SEARCH_OPTIONS: boolean;
  SET_MODULES: Array<any>;
  PAN_TO_STOP: number | null;
}
export interface MessageAction {
  type: keyof ActionTypes;
  payload: string | boolean | Array<any> | number | null;
}

export function setView(view: string): SearchOptionsViewTypes {
  return {
    type: SET_SEARCHOPTIONS_VIEW,
    payload: view,
  };
}
export function setShowSearchOptions(show: boolean): SearchOptionsViewTypes {
  return {
    type: SET_SHOW_SEARCH_OPTIONS,
    payload: show,
  };
}
export function setModules(modules: Array<any>): SearchOptionsViewTypes {
  return {
    type: SET_MODULES,
    payload: modules,
  };
}

export function panToStop(stopId: number | null): SearchOptionsViewTypes {
  return {
    type: PAN_TO_STOP,
    payload: stopId,
  };
}

export type SearchOptionsViewTypes = MessageAction;
